import { useRef, useEffect, type ChangeEvent, type KeyboardEvent, type FC } from 'react'
import styles from '../MenuCardInboxGroup/ui/styles.module.scss'

type IMenuItemInputProps = {
  value?: string
  placeholder?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onKeyUp?: (e: KeyboardEvent<HTMLInputElement>) => void
}

export const MenuCardInput: FC<IMenuItemInputProps> = ({
  value,
  placeholder,
  onChange,
  onKeyUp,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <input
      ref={inputRef}
      type='text'
      className={styles.input}
      placeholder={placeholder}
      value={value}
      onChange={(e) => {
        onChange && onChange(e)
      }}
      onKeyUp={(e) => {
        onKeyUp && onKeyUp(e)
      }}
    />
  )
}
